import React from "react";

import Portal from "./portal";
import {CloseIcon} from "./icons";

import classes from "./fullscreenaudio.module.css";
import cn from "classnames";

type props = React.ComponentProps<"audio"> & {
  onClose: (e: React.MouseEvent) => void,
}

export default function FullscreenAudio({onClose, className, ...props}: props) {
  return (
    <Portal>
      <div className={classes.root} onClick={onClose}>
        <div className={classes.container} onClick={(e) => e.stopPropagation()}>
          <audio
            className={cn(classes.audio, className)}
            controls
            autoPlay
            {...props}
          >
          </audio>
          <button className={classes.btn} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>
    </Portal>
  )
}

